import {
  IconChevronDown,
  IconChevronTop,
  GreyGrey0,
  GreyGrey20,
  GreyGrey30,
  GreyGrey70,
  Primary13SemiBold,
  Box,
  Flex,
  Grid,
  GridItem
} from '@sequencehq/core-components'
import { IntegrationGroupListItem } from './IntegrationGroupListItem'
import { useIntegrationsList } from './useIntegrationsList'
import { AvailableServices } from 'modules/Integrations/domain'

/**
 * TODO: similarly to the IntegrationsNavigation, it would be good to utilse the same navigation
 * item components here, rather than repeat the pattern with subtle tweaks. DAVIN-579.
 * @returns
 */
type IntegrationListProps = {
  activeIntegration: AvailableServices | null
  onSelectIntegration: (integration: AvailableServices) => void
}
export const IntegrationList = (props: IntegrationListProps) => {
  const hook = useIntegrationsList(props)

  return (
    <Flex
      flexDirection="column"
      gap="16px"
      backgroundColor={GreyGrey0}
      borderRight={`1px solid ${GreyGrey30}`}
      height="100%"
      padding="16px"
    >
      {hook.integrationGroups.map(group => (
        <Box key={group.id}>
          <Grid
            key={group.title}
            padding="0 8px"
            templateColumns="1fr auto"
            height="24px"
            alignContent="center"
            cursor="pointer"
            borderRadius="6px"
            _hover={{
              backgroundColor: GreyGrey20
            }}
            onClick={group.onClick}
            userSelect="none"
          >
            <GridItem
              {...Primary13SemiBold}
              color={GreyGrey70}
              textTransform="capitalize"
            >
              {group.title}
            </GridItem>
            <GridItem>
              {group.isExpanded ? (
                <IconChevronTop color={GreyGrey70} />
              ) : (
                <IconChevronDown color={GreyGrey70} />
              )}
            </GridItem>
          </Grid>
          {group.isExpanded && (
            <Flex flexDirection="column" gap="1px">
              {group.integrations.map(integration => (
                <IntegrationGroupListItem
                  key={integration.id}
                  {...integration}
                />
              ))}
            </Flex>
          )}
        </Box>
      ))}
    </Flex>
  )
}
